export default "__VITE_ASSET__D5jPKm7B__"